import store from '@/store/index'
import router from '@/router'
import { pageTrackEvent } from '@/common/utils/pageTrackEvent'

// 分转元
export const toYuan = (num: any) => {
	if (isNaN(num)) {
		return 0
	}
	return num / 100
}
// 获取高度(解决$message在iframe中展示问题)
export const getOffset = (triggerEl = null) => {
	if (store.state.isHeCheng) {
		try {
			let element = null as any;
			if (typeof triggerEl === 'string') {
				element = document.querySelector(triggerEl)
			} else if (triggerEl) {
				element = triggerEl
			}

			const bodyHeight =
				document.body.scrollHeight || document.documentElement.scrollHeight
			const popupHeight = 50
			let offsetTop = 0

			if (element) {
				// 获取元素距视口顶部位置
				const rect = element.getBoundingClientRect()
				console.log('rect', rect)
				// 计算元素距文档顶部位置 + 滚动高度 - 偏移高度
				// 上移 100px 避免遮挡元素
				const top = rect.top + window.scrollY - 200 // 上移 200px
				const remaining = bodyHeight - top
				offsetTop =
					remaining > popupHeight
						? top + popupHeight / 2
						: top - popupHeight / 2
			} else {
				// 没有触发元素，默认取视口 1/3 处
				const clientHeight =
					document.documentElement.clientHeight || window.innerHeight
				offsetTop = window.scrollY + clientHeight / 3
			}

			return Math.max(offsetTop, 20) // 至少距顶 20px
		} catch (err) {
			console.warn('getOffset 跨域计算失败', err)
			return 0
		}
	} else {
		if (self && self.frameElement && self.frameElement.tagName === 'IFRAME') {
			// 成都iframe
			const parentDoc = (window.parent && window.parent.document) || {}
			if (parentDoc.documentElement) {
				return parentDoc.documentElement.scrollTop || 0
			} else if (parentDoc.body) {
				return parentDoc.body.scrollTop || 0
			} else {
				return 0
			}
		} else {
			return 0
		}
	}
}

export const setWrapHeight = (dom: any) => {
	if (self && self.frameElement && self.frameElement.tagName === 'IFRAME') {
		// 成都iframe
		const parentDoc = (window.parent && window.parent.document) || ({} as any)
		if (parentDoc && parentDoc.getElementById('mainIframe')) {
			let iframeElement = parentDoc.getElementById('mainIframe') as any
			iframeElement.style.height = '5000px'
			if (dom) {
				setTimeout(() => {
					if (dom?.clientHeight) {
						iframeElement.style.height = dom.clientHeight + 20 + 'px'
					}
				}, 500)
			}
		}
	}
}

export const setPageHeight = (dom: any) => {
	if (dom) {
		if (dom?.clientHeight) {
			return dom.clientHeight + 20
		}
	} else {
		return 5000
	}
}

export const getCreateUrlWithActivityType = (activityType: number, router: any) => {
	let url = ''
	const token = store.state.isHeChengToken
	switch (activityType) {
		case 2:
			router.push({
				name: 'cptSimilarHotelCreate',
				query: {
					isHeCheng: store.state.isHeCheng,
					token,
				},
			})
			break
		case 6:
			router.push({
				name: 'cptWeChatMasterCreate',
				query: {
					isHeCheng: store.state.isHeCheng,
					token,
				},
			})
			break
		//流量快车
		case 7:
			router.push({
				name: 'createSearchPromotion',
				query: {
					isHeCheng: store.state.isHeCheng,
					type: 10,
					token,
				},
			})
			break
		//程艺推荐
		case 8:
			router.push({
				name: 'cptDecorateCreate',
				query: {
					isHeCheng: store.state.isHeCheng,
					token,
				},
			})
			break
		// 创建活动 精准营销
		case 9:
			router.push({
				name: 'marketCreate',
				query: {
					isHeCheng: store.state.isHeCheng,
					token,
				},
			})
			break
		//智能推荐
		case 12:
			const can_book = store.state.intelligentRecommendCanBooking || 1
			router.push({
				name: 'intelligenceRecommend',
				query: {
					isHeCheng: store.state.isHeCheng,
					can_book,
					token,
				},
			})
			break
		//品牌广告
		case 13:
			const brand_can_book = store.state.brandAdCanBooking || 1
			router.push({
				name: 'brandAdvertisement',
				query: {
					isHeCheng: store.state.isHeCheng,
					can_book: brand_can_book,
					token,
				},
			})
			break
		//市场活动
		case 16:
			router.push({
				name: 'cptMarketActivity',
				query: {
					isHeCheng: store.state.isHeCheng,
					token,
				},
			})
			break
		//CPS 聚意宝
		case 17:
			router.push({
				name: 'CpsContact',
				query: {
					isHeCheng: store.state.isHeCheng,
					token,
				},
			})
			break
		default:
			url = location.origin + url + store.state.isHeCheng
			break
	}
	return url
}

export const jumpTo = (name: string, query?: any) => {
	const isHeCheng = store.state.isHeCheng // 是否赫程
	const token = store.state.isHeChengToken // 赫程token
	router.push({
		name,
		query: {
			isHeCheng,
			token,
			...query,
		},
	})
}

export const eventTracking = (tabName: string, categoryName: string = '', action: string = 'click') => {
	const isHeCheng = store.state.isHeCheng // 是否赫程
	const mhotelName = store.state.mhotelName || ''
	const mhotelId = store.state.mhotelId || ''
	const shotelId = store.state.shotelId || ''
	const userName = store.state.userName || ''
	pageTrackEvent(
		`${action}`,
		`${isHeCheng ? 'EB-HC' : 'EB-TE'}`,
		`mhotelName:${mhotelName},mhotelId:${mhotelId},shotelId${shotelId},userName:${userName},tabName:${tabName}`,
		`${categoryName}`
	)
}

export const clickTracking = (tabName: string, categoryName: string = '', label: string = '') => {
	const mhotelName = store.state.mhotelName || ''
	const mhotelId = store.state.mhotelId || ''
	const shotelId = store.state.shotelId || ''
	const userName = store.state.userName || ''
	pageTrackEvent(
		'click',
		`${label}`,
		`mhotelName:${mhotelName},mhotelId:${mhotelId},shotelId:${shotelId},userName:${userName},tabName:${tabName}`,
		`${categoryName}`
	)
}

export const pageViewTracking = (tabName: string, categoryName: string = '', label: string = '') => {
	const mhotelName = store.state.mhotelName || ''
	const mhotelId = store.state.mhotelId || ''
	const shotelId = store.state.shotelId || ''
	const userName = store.state.userName || ''
	pageTrackEvent(
		'show',
		`${label}`,
		`mhotelName:${mhotelName},mhotelId:${mhotelId},shotelId:${shotelId},userName:${userName},tabName:${tabName}`,
		`${categoryName}`
	)
}

/**
 * @description 替换字符串中的占位符 占位符为 {{}}
 * @example replaceAll(["张三", "北京", "25"])("我是{{}}人，来自{{}}，今年{{}}岁") => "我是张三人，来自北京，今年25岁"
 */
export const replaceAll = (_arr: (string | number)[]) => (_str: string)  => {
	let index = 0
	const arr = _arr || []
	const str = _str || ''
	// 注意：{ 和 } 需要转义，所以是 \{\}
	return str.replace(/\{\{\}\}/g, (match, key) => {
		return arr[index++] + '' || match
	})
}

export const jsonParse = <T = [] | {}>(val: string, defaultValue: [] | {}) => {
  let res = defaultValue
  try {
    res = JSON.parse(val)
  } catch (e) {
    console.error('json parse 解析出错啦 e = ', e)
  }
  if (!res) res = defaultValue
  console.log('解析之后的结果 res = ', res)
  return res as T
}


const CHINESE_NUM_MAP = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
const CHINESE_UNIT_MAP = ['', '十', '百', '千']
const CHINESE_SECTION_UNIT_MAP = ['', '万', '亿']

const formatChineseNumberSection = (num: number) => {
  let currentNum = num
  let result = ''
  let unitIndex = 0
  let hasZero = false

  while (currentNum > 0) {
    const digit = currentNum % 10
    if (digit === 0) {
      if (!hasZero && result) {
        hasZero = true
        result = CHINESE_NUM_MAP[0] + result
      }
    } else {
      hasZero = false
      result = CHINESE_NUM_MAP[digit] + CHINESE_UNIT_MAP[unitIndex] + result
    }
    unitIndex += 1
    currentNum = Math.floor(currentNum / 10)
  }

  return result.replace(/零+$/, '')
}

/** 阿拉伯数字转成 中文数字 */
export const formatIntegerToChinese = (value: number | string | null | undefined, emptyValue = '') => {
  const num = Number(value)
  if (!Number.isInteger(num) || num < 0) return emptyValue
  if (num === 0) return CHINESE_NUM_MAP[0]

  let remainNum = num
  const sections: number[] = []
  let result = ''

  while (remainNum > 0) {
    sections.unshift(remainNum % 10000)
    remainNum = Math.floor(remainNum / 10000)
  }

  sections.forEach((sectionNum, sectionIndex) => {
    const sectionUnitIndex = sections.length - sectionIndex - 1
    if (sectionNum === 0) {
      if (result && !result.endsWith('零') && sections.some((item, index) => index > sectionIndex && item > 0)) {
        result += '零'
      }
      return
    }

    if (result && sectionNum < 1000 && !result.endsWith('零')) {
      result += '零'
    }
    result += formatChineseNumberSection(sectionNum) + CHINESE_SECTION_UNIT_MAP[sectionUnitIndex]
  })

  return result.replace(/^一十/, '十').replace(/零+/g, '零').replace(/零$/, '')
}
